import styled from "@emotion/styled";
import { Alert, AlertProps } from "@mui/material";

export const CustomAlert = styled((props: AlertProps) => <Alert {...props} />)(
  () => ({
   
  })
);
